import { plugin_annotate, plugin_crop, setPlugins } from "@pqina/pintura";
import { plugin_trim } from "@pqina/pintura-video";

// setPlugins is a global singleton — calling it from each modal would let
// import order decide which plugin set wins. Register the union here once
// and have both PinturaModal and PinturaVideoModal import this module for
// side effects.
//
// Order matters: Pintura uses registration order to pick the default util
// for the loaded source. plugin_trim is video-only (no-ops on image
// sources), so listing it first makes Trim the default tab for video
// without affecting image behavior — for images, the editor falls through
// to crop, the next applicable util.
setPlugins(plugin_trim, plugin_crop, plugin_annotate);
